import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, Marca, RetAPI, Serie, TablePages, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { useNavigate } from 'react-router-dom'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import moment from 'moment'
import { SerieService } from '../../Pages/Serie_Doc_Fiscal/SerieDocService'
import { Tooltip } from 'react-tooltip'
import { FaTrashAlt } from 'react-icons/fa'
import { RiEdit2Fill } from 'react-icons/ri'

type Props = {
    serie: Serie[],
    handleUpdateSerieList: () => void
}

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number,
    num_doc: number,
    modelo: number,
    serie: number,
    //description: string,
    dt_cadastro: string,
}

export const GridSerieDoc = React.memo(({ serie, handleUpdateSerieList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_serieDoc")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_serieDoc") || '')
                : {
                    acao: true,
                    num_doc: true,
                    modelo: true,
                    serie: true,
                    dt_cadastro: true,
                }
        )
    }, [])

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_serieDoc")

    let json: any = {
        acao: true,
        num_doc: true,
        modelo: true,
        serie: true,
        dt_cadastro: true,
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_serieDoc") || '')
    }
    */

    /*
    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }
                newColumnVisibility.acao = json.acao
                newColumnVisibility.num_doc = json.num_doc
                newColumnVisibility.modelo = json.modelo
                newColumnVisibility.serie = json.serie
                newColumnVisibility.dt_cadastro = json.dt_cadastro
            }
        }

    }, [])
    */

    const [idSerie, setIdSerie] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [series, setSeries] = useState<Serie[]>([])
    const [nomeSeries, setNomeSeries] = useState("")

    let user = useSelector(state => selectUser(state))

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setSeries(serie)
    }, [serie])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_serieDoc", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await SerieService.Delete(idSerie, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Serie excluída com sucesso`)

                handleUpdateSerieList()

                //setSeries(await SerieService.Filter('', ''))
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                // setModalShow(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir a série de documento fiscal. Por favor, tente novamente`)
        }
    }, [idSerie])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_serie")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeSeries("")
        }
        
    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeSeries("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaSerieEdit = (id: number) => {
        navigate(`/serieDoc/edit/${id}`)
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const colunas = useMemo<MRT_ColumnDef<Serie>[]>(
        () => [

            {
                accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: true, size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: ((cell: any) => {

                    const rowData = cell.row.original as RowData

                    const navegar = () => {
                        navegarTelaSerieEdit(rowData.id)
                    }

                    const handleExcluirClick = () => {

                        const timerExcluir = setTimeout(() => {
                            setIdSerie(rowData.id)
                            setNomeSeries(rowData.num_doc.toString())
                            setModalShow(true)
    
                            let divPerfil = document.getElementById('div-perfil') as HTMLDivElement
    
                            if (divPerfil) {
                                divPerfil.classList.add('hidden')
                            }
    
                            let menuFiltro = document.getElementById("divMenuFiltroSerie") as HTMLDivElement
                            let menuInputs = document.getElementById("divInputsSerie") as HTMLDivElement
    
                            if (menuFiltro) {
    
                                menuInputs.classList.add("invisible")
    
                                const timer = setTimeout(() => {
                                    menuFiltro.classList.remove("max-h-[390px]")
                                    menuFiltro.classList.add("max-h-[0px]")
                                    Inputfocus()
                                    clearTimeout(timer)
                                }, 100)
                            }

                            clearTimeout(timerExcluir)
                        }, 0);

                    }

                    return (
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`}>
                                <RiEdit2Fill size="20px" />

                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <FaTrashAlt size="18px" />
                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                    <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                                </Tooltip>
                            </button>

                        </div>
                    )
                })
            },

            {
                accessorKey: 'num_doc', visibleInShowHideMenu: true, header: 'Número do Documento', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.num_doc ? rowData.num_doc : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'modelo', visibleInShowHideMenu: true, header: 'Modelo', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.modelo ? rowData.modelo : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'serie', visibleInShowHideMenu: true, header: 'Serie', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.serie ? rowData.serie : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    if (rowData.dt_cadastro != '' && rowData.dt_cadastro != null) {

                        const dataMarca = moment(rowData.dt_cadastro).format('DD/MM/YYYY')

                        return (<span>{dataMarca}</span>)

                    } else {

                        return (<span className='text-red-400'>N/D</span>)
                    }
                }
            },

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: series,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir o documento fiscal - ${nomeSeries || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )

})